<template>
  <div class="mk-artist-form row">
    <div class="px-0 mb-0 col-12 d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-md-center align-items-start">
      <h1 class="ml-0 mb-0">{{ artist.name || "New Creator" }}</h1>

        <div class="d-flex flex-column flex-md-row">
            <a
                @click="handleSubmit()"
                class="btn btn-success mb-3 mb-md-0 ml-md-3"
            >
                Save
            </a>

            <a
                v-if="artist.id"
                @click="handleDelete()"
                class="btn btn-danger mb-3 mb-md-0 ml-md-3"
            >
                Delete
            </a>
        </div>
    </div>

    <div class="container-fluid">
        <artist-form :artist="artist" ref="artistFormRef"></artist-form>
    </div>

    <!-- <div class="container-fluid" v-if="artist.id">
        <artist-artworks :initial_artist="artist"></artist-artworks>
    </div> -->


  </div>
</template>

<script>
import Artist from "../../models/Artist";
export default {
  props: {
    init_artist: {
      type: Object,
    },
  },
  data() {
    return {
      artist: new Artist(this.init_artist),
    };
  },
  computed: {},
  methods: {
    handleDelete() {
      this.$swal({
        title: "Are you sure you want to delete this?",
        customClass: {
          confirmButton: "order-2 btn btn-danger ml-1",
          cancelButton: "order-1 btn hf-btn-secondary mr-1",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Confirm",
        iconHtml: "",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let artist = new Artist(this.initial_artist);
          artist.delete().then((response) => {
            window.location.href = "/admin/artists";
          });
        }
      });
    },

    handleSubmit() {
      this.$refs.artistFormRef.handleSubmit();
    },
  },
};
</script>
